export default {
  title: "Online Catalog",
  tabs: {
    products: "Products and Services",
    categories: "Categories",
  },
  buttons: {
    qrCode: "QR Code",
    create: "Create",
  },
  modals: {
    limit: {
      title: "You've created the maximum number of products on your tariff",
      subtitle: "To create more products, upgrade your tariff.",
      cancel: "Cancel",
      toTariffs: "To Tariffs",
    },
  },
  statuses: {
    allProducts: "All Products",
    allCategories: "All Categories",
    confirmed: "Confirmed",
    moderation: "Under Moderation",
    rejected: "Rejected",
    basic: "Basic",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "No products in the online catalog yet",
        description: "First create a trading point, then you can add products",
        buttonText: "To Trading Points",
      },
      noProducts: {
        title: "No products in the online catalog yet",
        buttonText: "Create Product",
      },
    },
    categories: {
      title: "No data yet",
      description:
        "It will appear here after creating a product and attaching it to one of the basic categories, or after creating a custom category.",
      buttonText: "Create Category",
    },
  },
  formErrors: {
    empty: "Field cannot be empty",
    price: "Value must be greater than 0",
    discount: "Value must be less than the price without discount",
  },
  exitModal: {
    creating: {
      title: "Cancel product creation?",
      subtitle:
        "Entered product information will not be saved. To return to editing, click 'Back'.",
      backButton: "Back",
      confirmButton: "Yes, Cancel",
    },
    editing: {
      title: "Delete the changes made?",
      subtitle:
        "If you need to save them, go back. Otherwise, all changes made will not be applied. The product card will display previously saved data.",
      backButton: "Go Back and Save",
      confirmButton: "Delete",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Category rejected by moderator",
      default: "Enter category name",
    },
    subtitle: {
      rejected: "Change the name and submit the category for moderation.",
      rejectedWithMessage:
        "Change the name and submit the category for moderation.",
      default:
        "The category will become available for selection when creating new products and will be displayed with the specified name in RC PAY only after passing moderation.",
    },
    buttons: {
      cancel: "Cancel",
      sendForModeration: "Submit for Moderation",
    },
    notification: {
      success: "Category submitted for moderation",
    },
  },
  categoryDeleteModal: {
    title: "Are you sure you want to delete the category '{name}'?",
    subtitle:
      "Products related to it will be assigned the basic value 'No Category'",
    buttons: {
      cancel: "Cancel",
      delete: "Delete",
    },
    notification: {
      deleted: "Category deleted",
    },
  },
  productCard: {
    labels: {
      name: "Product Name",
      category: "Category",
      measurementUnit: "Unit of Measurement",
      price: "Price, {currency}",
      discountPrice: "Discount Price, {currency}",
      sku: "SKU",
      barcode: "Barcode",
      description: "Description",
      tradingPointsVisibility: "Display in Trading Points",
      productImages: "Product Images",
      showInCatalog: "Display product in Online Catalog",
      showInCatalogDescription:
        "The product will be displayed in RC PAY in the Online Catalog of selected trading points after passing moderation.",
    },
    placeholders: {
      selectCategory: "Select Category",
      selectMeasurementUnit: "Select Unit of Measurement",
      sku: "up to 30 characters",
      selectTradingPoints: "Select Trading Points",
    },
    buttons: {
      cancel: "Cancel",
    },
    notifications: {
      fillRequiredFields: "Please correctly fill all required fields",
      savedAndSentForModeration: "Changes saved and submitted for moderation",
      successfullySaved: "Changes successfully saved",
    },
    moderationMessage: {
      title: "Message from Moderation",
    },
    measurementUnits: {
      none: "No Units of Measurement",
    },
    imageRequirements: {
      aspectRatio: "Image aspect ratio — 1:1",
      fileTypes: "JPEG, JPG, PNG — up to 5 files, each no more than 10 MB",
    },
    imageCropper: {
      subtitle:
        "The selected area will be displayed in the product card in the Online Catalog in RC PAY.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Name",
      category: "Category",
      price: "Price",
      status: "Status",
    },
  },
  productsDeleteModal: {
    title: "Are you sure you want to delete the specified product?",
    buttons: {
      cancel: "Cancel",
      delete: "Delete",
    },
  },
  productsQRModal: {
    title: "Menu QR Code",
    subtitle:
      "Select the trading point whose online catalog QR code you want to download",
    tradingPoint: "Trading Point",
    downloadButton: "Download QR Code",
  },
  productsSaveModal: {
    title: "Some of the changes made require moderation",
    subtitle:
      "In the product card displayed in RC PAY, they will only update after being checked and confirmed by a moderator.",
    buttons: {
      cancel: "Cancel",
      sendForModeration: "Submit for Moderation",
    },
  },
  productVisible: {
    messages: {
      visible: "Displayed in RC PAY",
      hidden: "Hidden in RC PAY",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Newly Created First",
      alphabeticalAsc: "Name A to Z",
      alphabeticalDesc: "Name Z to A",
      productsCountAsc: "Fewer Products First",
      productsCountDesc: "More Products First",
    },
    buttons: {
      create: "Create",
    },
    search: {
      placeholder: "Search Categories",
    },
    status: {
      label: "Category Status",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Newly Created First",
      alphabeticalAsc: "Name A to Z",
      alphabeticalDesc: "Name Z to A",
      priceAsc: "Price Low to High",
      priceDesc: "Price High to Low",
    },
    buttons: {
      create: "Create",
    },
    search: {
      placeholder: "Search",
    },
    labels: {
      category: "Category",
      tradingPoints: "Trading Points",
      status: "Status",
    },
  },
  productDrawer: {
    title: {
      edit: "Product Information",
      create: "Create Product",
    },
    saveButton: {
      saveAndExit: "Save and Exit",
      sendForModeration: "Submit for Moderation",
    },
    errors: {
      imageUpload:
        "Some images could not be processed. Try uploading different ones.",
    },
  },
};
